import React, { Component } from "react";
import _ from "lodash";
import "./index.scss";
import {
  getRequest,
  postRequest,
  deleteRequest,
} from "../../../../utils/httpRequest";
import FormModal from "../../Offers/components/SelectTrade/components/OnlineWallet/FormModal.jsx";
import Table from "./Table";
import BCSuccess from "../../Feedbacks/bcsuccess";
import DeleteModal from "../deleteModal.jsx";
import { t } from "../../../../utils/i18n";

class OnlineWallets extends Component {
  constructor(props) {
    super(props);

    this.state = {
      walletName: "online-wallets",
      url: "",
      wallets: [],
      caption: "",
      isSubmitting: false,
      isLoading: false,
      isModalOpen: false,
      shouldDelete: false,
      walletToDelete: "",
    };
  }

  componentDidMount() {
    this.getOnlineWallets();
  }

  getOnlineWallets = () => {
    this.setState({ isLoading: true });
    getRequest("/p2p_trades/online_wallets").then((response) => {
      this.setState({
        wallets: response,
        isLoading: false,
      });
    });
  };

  showSuccess = () => {
    const bcsuccess = document.querySelector("#onlinewalletspage-success-feedback");
    bcsuccess.style.display = 'block';
    setTimeout(() => {
      bcsuccess.style.display = 'none';
    }, 5000);
  }

  closeDeleteModal = () => {
    const deleteModal = document.querySelector('#onlinewalletspage-delete-modal');
    deleteModal.style.display = "none" 
  }

  deleteWallet = (e, id) => {
    e.preventDefault();
    this.walletToDelete = id;
    const deleteModal = document.querySelector('#onlinewalletspage-delete-modal');
    deleteModal.style.display = "flex" 
  }

  proceedToDeleteWallet = () => {
    const { wallets } = this.state;
    if (this.shouldDelete) {
      deleteRequest(`/p2p_trades/online_wallets/${this.walletToDelete}`).then(() => {
        _.remove(wallets, (wallet) => wallet.id === this.walletToDelete);

        this.setState({
          updateWallets: wallets,
        })
      });
      this.showSuccess();
      this.setState({
        shouldDelete: false,
        walletToDelete: "",
      })
    }
  };

  handleShouldDelete = (e) => {
    e.preventDefault();
    this.shouldDelete = true;
    this.proceedToDeleteWallet();
    this.closeDeleteModal();
  }

  // deleteWallet = (e, id) => {
  //   e.preventDefault();

  //   const { wallets } = this.state;

  //   const shouldDelete = window.confirm("Are you sure?");

  //   if (shouldDelete) {
  //     deleteRequest(`/p2p_trades/online_wallets/${id}`).then(() => {
  //       _.remove(wallets, (wallet) => wallet.id === id);

  //       const updatedWallets = [...wallets];

  //       this.setState({ wallets: updatedWallets });
  //     });

  //     this.showSuccess();
  //   }
  // };

  handleInputChange = (e, key) => {
    this.setState({ [key]: e.target.value });
  };

  onSubmit = (e) => {
    e.preventDefault();

    this.setState({ isSubmitting: true });

    const { walletName, url, caption } = this.state;

    const params = {
      url,
      caption,
      wallet_name: walletName,
    };

    postRequest("/p2p_trades/online_wallets", params)
      .then((response) => {
        this.updateWallets(response);
        this.setState({ url: "", caption: "" });

        this.toggleOpenModal(e);
        this.showSuccess();
      })
      .catch((error) => {
        this.setState({ isSubmitting: false });
        console.log(error);
      });
  };

  toggleOpenModal = (e) => {
    e.preventDefault();
    this.setState({ url: "", caption: "" });
    this.setState({ isModalOpen: !this.state.isModalOpen });
  };

  handleWalletChange = (selectedOnlineWallet) => {
    this.setState({ selectedOnlineWallet });
  };

  updateWallets = (newWallet) => {
    this.setState((prevState) => ({
      wallets: [...prevState.wallets, newWallet],
      selectedOnlineWallet: newWallet,
      isSubmitting: false,
    }));
  };

  render() {
    const {
      wallets,
      walletName,
      url,
      caption,
      selectedOnlineWallet,
      isModalOpen,
      isLoading,
      isSubmitting,
    } = this.state;

    return (
      <>
        <div id="onlinewalletspage-success-feedback">
          <BCSuccess />
        </div>
        <div id="onlinewalletspage-delete-modal">
          <DeleteModal 
            closeDeleteModal={this.closeDeleteModal}
            handleShouldDelete={this.handleShouldDelete}
          />
        </div>
        <div className="onlinewalletspage-container">
          {/* page header */}
          <div className="onlinewalletspage-section">
            <h3 className="_page-title">{" "}</h3>
            <div className="onlinewalletspage-nav">
              {/* add online wallet */}
              <div className="onlinewalletspage_nav-item">
                <button
                  type="button"
                  className="onlinewalletspage_nav-item-btn"
                  onClick={this.toggleOpenModal}
                >
                  <svg
                    className="_icon"
                    width="19"
                    height="22"
                    viewBox="0 0 19 22"
                    fill="#F79237"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.71429 0.5C1.21719 0.5 0 1.84531 0 3.5V18.5C0 20.1547 1.21719 21.5 2.71429 21.5H16.2857C17.7828 21.5 19 20.1547 19 18.5V3.5C19 1.84531 17.7828 0.5 16.2857 0.5H2.71429ZM8.48214 15.125V12.125H5.76786C5.20379 12.125 4.75 11.6234 4.75 11C4.75 10.3766 5.20379 9.875 5.76786 9.875H8.48214V6.875C8.48214 6.25156 8.93594 5.75 9.5 5.75C10.0641 5.75 10.5179 6.25156 10.5179 6.875V9.875H13.2321C13.7962 9.875 14.25 10.3766 14.25 11C14.25 11.6234 13.7962 12.125 13.2321 12.125H10.5179V15.125C10.5179 15.7484 10.0641 16.25 9.5 16.25C8.93594 16.25 8.48214 15.7484 8.48214 15.125Z"
                      fill="#F79237"
                    />
                  </svg>{" "}
                  {t("p2p.wallets.add")}
                </button>
              </div>

              <div className="onlinewalletspage_nav-item">
                <button
                  type="button"
                  className="onlinewalletspage_nav-item-btn"
                  onClick={() => window.open("https://www.bananacrystal.com/docs/add-online-wallet/", "_blank")}
                  >
                  <svg
                    className="_icon"
                    width="20"
                    height="24"
                    viewBox="0 0 20 24"
                    fill="#F79237"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 0C7.82292 0 5.96875 1.25156 5.28646 3H3.33333C1.49479 3 0 4.34531 0 6V21C0 22.6547 1.49479 24 3.33333 24H16.6667C18.5052 24 20 22.6547 20 21V6C20 4.34531 18.5052 3 16.6667 3H14.7135C14.0312 1.25156 12.1771 0 10 0ZM10 3C10.442 3 10.866 3.15804 11.1785 3.43934C11.4911 3.72064 11.6667 4.10218 11.6667 4.5C11.6667 4.89782 11.4911 5.27936 11.1785 5.56066C10.866 5.84196 10.442 6 10 6C9.55797 6 9.13405 5.84196 8.82149 5.56066C8.50893 5.27936 8.33333 4.89782 8.33333 4.5C8.33333 4.10218 8.50893 3.72064 8.82149 3.43934C9.13405 3.15804 9.55797 3 10 3ZM5.51042 10.7484C5.92187 9.70313 7.02604 9 8.26042 9H11.2969C13.1146 9 14.5833 10.3266 14.5833 11.9578C14.5833 13.0172 13.9531 13.9969 12.9323 14.5266L11.25 15.3937C11.2396 16.0031 10.6823 16.5 10 16.5C9.30729 16.5 8.75 15.9984 8.75 15.375V14.7422C8.75 14.3391 8.98958 13.9688 9.38021 13.7672L11.6875 12.5766C11.9323 12.45 12.0833 12.2156 12.0833 11.9625C12.0833 11.5687 11.7292 11.2547 11.2969 11.2547H8.26042C8.08333 11.2547 7.92708 11.3531 7.86979 11.5031L7.84896 11.5594C7.61979 12.1453 6.90104 12.45 6.25521 12.2438C5.60937 12.0375 5.26562 11.3906 5.49479 10.8094L5.51562 10.7531L5.51042 10.7484ZM8.33333 19.5C8.33333 19.1022 8.50893 18.7206 8.82149 18.4393C9.13405 18.158 9.55797 18 10 18C10.442 18 10.866 18.158 11.1785 18.4393C11.4911 18.7206 11.6667 19.1022 11.6667 19.5C11.6667 19.8978 11.4911 20.2794 11.1785 20.5607C10.866 20.842 10.442 21 10 21C9.55797 21 9.13405 20.842 8.82149 20.5607C8.50893 20.2794 8.33333 19.8978 8.33333 19.5Z"
                      fill="#F79237"
                    />
                  </svg>
                  {" "}
                  {t("p2p.common.user_guide")}
                </button>
              </div>
            </div>
          </div>

          {/* table component */}
          <div className="onlinewalletspage_page-table">
            <Table
              wallets={wallets}
              loading={isLoading}
              deleteWallet={this.deleteWallet}
            />
            {isModalOpen && (
              <FormModal
                walletName={walletName}
                url={url}
                caption={caption}
                isSubmitting={isSubmitting}
                handleCloseModal={this.toggleOpenModal}
                handleInputChange={this.handleInputChange}
                onSubmit={this.onSubmit}
              />
            )}
          </div>
        </div>
      </>
    );
  }
}

export default OnlineWallets;
